import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { GetChannelMiniEpgUseCase } from './GetChannelMiniEpgUseCase';
import { GetChannelsArrisSTBUseCase } from './GetChannelsArrisSTBUseCase';
import { GetChannelScheduleUseCase } from './GetChannelScheduleUseCase';
import { GetChannelScheduleByDataSourceUseCase } from './GetChannelScheduleByDataSourceUseCase';
import { GetChannelsUseCase } from './GetChannelsUseCase';
import { GetAllChannelsUseCase } from './GetAllChannelsUseCase';
import { GetChannelInfoUseCase } from './GetChannelInfoUseCase';

export const initializeChannelUseCase = (container: Container) => {
    container.register(DI.USECASES.IGetChannelMiniEPGUseCase, {
        useClass: GetChannelMiniEpgUseCase,
    });
    container.register(DI.USECASES.IGetChannelsArrisSTBUseCase, {
        useClass: GetChannelsArrisSTBUseCase,
    });
    container.register(DI.USECASES.IGetChannelScheduleUseCase, {
        useClass: GetChannelScheduleUseCase,
    });
    container.register(DI.USECASES.IGetChannelScheduleByDataSourceUseCase, {
        useClass: GetChannelScheduleByDataSourceUseCase,
    });
    container.register(DI.USECASES.IGetChannelsUseCase, {
        useClass: GetChannelsUseCase,
    });
    container.register(DI.USECASES.IGetAllChannelsUseCase, {
        useClass: GetAllChannelsUseCase,
    });
    container.register(DI.USECASES.IGetChannelInfoUseCase, {
        useClass: GetChannelInfoUseCase,
    });
};
